module.exports = __webpack_public_path__ + "static/media/seo.ff2cdfad.png";